import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import {calendarDate} from 'shared/tools';
import TimeOffTypePolicy from './TimeOffTypePolicy';
import _ from 'lodash';

class TimeOffPolicy extends DomainObject {
  id;
  name;
  typePolicies;
  currentYearStartDate;
  currentYearEndDate;
  nextYearStartDate;
  workDayLength;
  workWeekDays;
  startDay;
  startMonth;
  employees;
  completed;
  sendEmployeeWelcomeNotifications;

  _relations = {
    typePolicies: [TimeOffTypePolicy],
    employees: [Employee],
    _dates: ['currentYearStartDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      typePolicies: observable,
      currentYearStartDate: observable,
      currentYearEndDate: observable,
      nextYearStartDate: observable,
      workDayLength: observable,
      workWeekDays: observable,
      startDay: observable,
      startMonth: observable,
      employees: observable,
      completed: observable,
      sendEmployeeWelcomeNotifications: observable,
      sortedTypePolicies: computed,
      currentYearStartDateView: computed,
      currentYearEndDateView: computed,
      nextYearStartDateView: computed
    });

    this.merge(other);
  }

  get sortedTypePolicies() {
    return _.sortBy(this.typePolicies, 'type.order');
  }

  get currentYearStartDateView() {
    return calendarDate(this.currentYearStartDate);
  }

  get currentYearEndDateView() {
    return calendarDate(this.currentYearEndDate);
  }

  get nextYearStartDateView() {
    return calendarDate(this.nextYearStartDate);
  }
}

export default TimeOffPolicy;
